export default {"src":"/_next/static/media/data-subject-access-requests.f95d2210.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};